import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PersonalCertificateComponent } from '../../account/personal-certificate/personal-certificate.component';
import { IgnoreCertificateComponent } from '../ignore-certificate/ignore-certificate.component';
import { IdexService } from 'app/idex.service';
import { Toast } from 'app/shared/toast/toast';


@Component({
  selector: 'app-confirm-certificate',
  templateUrl: './confirm-certificate.component.html'
})
export class ConfirmCertificateComponent{


  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
             private dialog: MatDialog, public service: IdexService,  private toast: Toast) { }

  openPersonalCert() {
    this.dialog.open(PersonalCertificateComponent, {
       disableClose: true,
       data: this
    });
 }

  ignoreCert(){
    this.dialog.open(IgnoreCertificateComponent, {
      disableClose: true,
      data: this
    });
  }
}